export default __webpack_public_path__ + "static/media/43bde741d50b850f3b783edc8ef26b5e1600805498081.1fbefda2.webp";